import { compose, withProps, lifecycle } from 'recompose';

import { PercentageInput } from '../';
import withCurrentStaffingCompanyGroup from '../../../containers/withCurrentStaffingCompanyGroup';
import requireProps from '../../../lib/requireProps';
import { withTranslation } from 'react-i18next';

export default compose(
  withTranslation(),
  withCurrentStaffingCompanyGroup,
  requireProps(['currentStaffingCompanyGroup']),
  withProps(({ currentStaffingCompanyGroup: { holidayPayRate }, t }) => ({
    defaultValue: holidayPayRate,
    info: t('vacationTimeIsIncludedWithHourlyRate'),
  })),
  lifecycle({
    componentDidMount() {
      if (parseInt(this.props.input.value, 10) === 0) {
        compose(
          this.props.input.onChange,
          PercentageInput.format,
        )(this.props.defaultValue);
      }
    },
  }),
)(PercentageInput);
